import {get} from "@/context/context";
import {LevelsRepository} from "@/repositories/LevelsRepository";
import {Level} from "@/models/Level";
import API from "@/utils/Api";
import {Servers} from "@/serverConfig";

export class LevelsService {

    private api: API = get('api');
    public levelsRepository: LevelsRepository = get('levelsRepository');

    public async getLevels(): Promise<Level[]> {
        this.api.changeServer(Servers.BACK);
        return await this.levelsRepository.getLevels();
    }
}
